import React from 'react'
import {DesktopMenu} from 'components/MainMenu/MainMenu'


export default class Header extends React.Component {
  render() {
    return (
      <header className="header">
        <nav className="nav">
          <h1 className="logo">
            <a href="http://sketchize.com/">
              <img src={require('assets/images/header-logo.svg')} title="sketchize-logo" alt="sketchize-logo"/>
            </a>
            <span className="logo-text">Sketchize</span>
          </h1>
          <DesktopMenu />
          <a className="hamburger-menu toggle"><span className="sketch-hamburger-menu"><span className="path1"></span><span className="path2"></span><span className="path3"></span></span></a>
        </nav>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js